import * as React from 'react';
import { Suggestion } from '../suggestion';
import { config } from '../../../../config';
import { Path } from '../../../..';
import { composer } from '../../../../component-decorators/composer';
import { SuggestionType } from '../../../../types/common/marketplace';
export var PopularSuggestions = composer()
    .withTranslation()
    .withBiLogger()
    .compose(function (_a) {
    var searchTerms = _a.searchTerms, searchValue = _a.searchValue, addSelectedNode = _a.addSelectedNode, onSearchValueChange = _a.onSearchValueChange, sendSearchSearchClickBi = _a.sendSearchSearchClickBi;
    var removeSpaces = function (str) { return str && str.replace(/\s/g, ''); };
    return (React.createElement(React.Fragment, null, searchTerms.map(function (term) { return (React.createElement(Suggestion, { key: removeSpaces(term.name), suggestionKey: removeSpaces(term.name), value: term.name, suggestionType: SuggestionType.SEARCH, onClick: function () {
            onSearchValueChange(term.name);
            sendSearchSearchClickBi(searchValue, 'autocomplete', term.index);
            config.goto({ path: Path.SEARCH, query: term.name });
        }, selected: term.selected, index: term.index, addSelected: addSelectedNode })); })));
});
//# sourceMappingURL=popular-suggestions.js.map